import {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {Button, Checkbox, Input, Popconfirm, Radio, Select, Table} from "antd";
import {Menu as MENU, Trash2, X} from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";
import $ from "jquery";

export default function AddCeilings() {
    const location = useLocation();
    const history = useHistory();
    const [isMobileShow, setIsMobileShow] = useState(false);
    // States for each form input
    const [isLoading, setIsLoading] = useState(false);
    const [wallsData, setWallsData] = useState([]);
    const [wallName, setWallName] = useState('');

    useEffect(() => {
        LoadWalls();
    }, []);
    const LoadWalls = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "GetCeilingName");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setWallsData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const submitHandle = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            var form = $('.SubmitForm');
            if (!form[0].checkValidity()) {
                toast.warn("Fill all the required(*) fields.")
            } else {
                const formData = new FormData();
                formData.append("page", "SaveCeilingName");
                formData.append("name", wallName);


                try {
                    let toaster;
                    form.find("button").attr("disabled", true);
                    toaster = toast.loading("Processing...");
                    await fetch(`${API_LINK}Walls.php`, {
                        method: 'POST',
                        body: formData,
                        redirect: "follow",
                    })
                        .then(response => response.json())
                        .then(result => {
                            console.log(result);
                            if (result.status === 1) {
                                setTimeout(async () => {
                                    toast.update(toaster, {
                                        type: "success",
                                        render: "You have successfully added a new ceiling.",
                                        isLoading: false,
                                        autoClose: toaster,
                                        closeButton: true,
                                        pauseOnHover: false,
                                        pauseOnFocusLoss: false,
                                        closeOnClick: true,
                                    })
                                    form.find("button").attr("disabled", false);
                                    form.trigger("reset");
                                    setWallName("");
                                    await LoadWalls();
                                }, 1000)
                            }
                        })
                    form.find("button").attr("disabled", false);
                } catch (error) {
                    console.error('Error in the fetch request:', error);
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    async function deleteWall(id) {
        let toaster;
        toaster = toast.loading("Processing...");
        try {
            const formdata = new FormData();
            formdata.append("page", "DeleteCeilingName");
            formdata.append("id", id);
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    if (result.status === 1) {
                        setTimeout(() => {
                            toast.update(toaster, {
                                type: "success",
                                render: "Record Deleted!",
                                isLoading: false,
                                autoClose: toaster,
                                closeButton: true,
                                pauseOnHover: false,
                                pauseOnFocusLoss: false,
                            })
                        }, 1000)
                        LoadWalls();
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                })
                .catch(error => console.log('error', error));
        } catch (e) {
            console.log(e);
        }
    }

    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <form className='SubmitForm' onSubmit={submitHandle}>
                    <div className="content">
                        <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                            <MENU size={16}/>
                            <span>Show Menu</span>
                        </button>
                        <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                                onClick={() => setIsMobileShow(false)}>
                            <X size={16}/>
                        </button>
                        <h2>Add Ceiling</h2>
                        <span>want to add more ceilings?</span>

                        <div className="content-card">
                            <div className="table-search">
                                <button type={"button"} className='btn-card-header'
                                        onClick={() => history.goBack()}>Back To Ceilings
                                </button>
                            </div>
                            <div className="row">
                                {/* Wall Selection */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Ceiling Name</label>
                                        <input type="text" required placeholder={'...'} value={wallName}
                                               onChange={(e) => setWallName(e.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="">&nbsp;&nbsp;&nbsp;</label>
                                        <button type='submit' className='btn-back-dashboard'>Save</button>
                                    </div>
                                </div>
                            </div>
                            <Table dataSource={wallsData} pagination={{pageSize: 10}}
                                   loading={isLoading}
                                   rowHoverable={true} style={{marginTop: 40}}>
                                <Table.Column title="#" width={70} render={(j, r, index) => {
                                    return (<span>{index + 1}</span>)
                                }}/>
                                <Table.Column title="Ceiling Name" dataIndex="Name"/>
                                {
                                    <Table.Column title="Delete" render={(j) => {
                                        return (
                                            <Popconfirm title={'Are you sure?'}
                                                        description={'You want to remove this ceiling?'}
                                                        onConfirm={() => {
                                                            deleteWall(j.id)
                                                        }}
                                            >
                                                <Button type='primary' danger icon={<Trash2 size={15}/>}/>
                                            </Popconfirm>
                                        )
                                    }}/>
                                }
                            </Table>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </>)
}
